import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from "lodash";
import { Modal, ModalBody, Button, Label } from 'reactstrap';
import { sharedLabelsPath } from '../../../../../reducers/common/localization';
import './WireDataModal.css';

class WireDataModal extends Component {
    render() {
        if (!this.props.wireData) {
            return null;
        }

        return (
            <Modal isOpen={this.props.isOpen}>
                <ModalBody>
                    <h6>{_.get(this.props.translation, 'system_payment.wire_data_modal_label').replace("{name}", this.props.name)}</h6>
                    <Label>
                        {this.props.wireData}
                    </Label>
                    <div className="wire-data-modal-button-container">
                        <Button className="olive-green-btn" onClick={this.props.onCancel}>
                            {_.get(this.props.translation, sharedLabelsPath.okey_button)}
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

WireDataModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    wireData: PropTypes.string,
    name: PropTypes.string,
    translation: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default WireDataModal;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/duePaymentsList/wireDataModal/WireDataModal.js